import React from 'react'
import PropTypes from 'prop-types'
import FormInput from 'components/forms/bases/FormInput'
import { returnNumber } from 'helpers/numberHelpers'

const FormInputNumber = ({ onChange, ...props }) => {
  return (
    <FormInput
      {...props}
      type="number"
      onChange={(val) => returnNumber(val, onChange)}
    />
  )
}

FormInputNumber.propTypes = {}
FormInputNumber.defaultProps = {}

export default FormInputNumber



// WEBPACK FOOTER //
// ./src/components/forms/FormInputNumber.js